import { render, staticRenderFns } from "./EstablishmentYearSettingInfo.vue?vue&type=template&id=23b42179&scoped=true&"
import script from "./EstablishmentYearSettingInfo.vue?vue&type=script&lang=js&"
export * from "./EstablishmentYearSettingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b42179",
  null
  
)

export default component.exports